import React, { useState, useEffect } from "react";
import { Grid, TextField, Select, MenuItem, Button, InputLabel, FormControl, Box } from "@mui/material";

export default function ProductForm({ producto, onAdd }) {
  const [pvp, setPvp] = useState("");
  const [ivaPorcentaje, setIvaPorcentaje] = useState(15);
  const [ivaValor, setIvaValor] = useState("0.00");
  const [descuentoPct, setDescuentoPct] = useState("0");
  const [stock, setStock] = useState(0);
  const [detalles, setDetalles] = useState("");
  const [imagen, setImagen] = useState("");
  const [brand, setBrand] = useState("");

  useEffect(() => {
    if (producto) {
      const precio = Number(producto.pvp1 || 0);
      setPvp(precio.toFixed(2));
      setIvaPorcentaje(Number(producto.iva_porcentaje ?? 15));
      setIvaValor(((precio * Number(producto.iva_porcentaje ?? 15)) / 100).toFixed(2));
      setDescuentoPct(String(Number(producto.descuentoPct || 0)));
      setStock(Number(producto.stock ?? 0));
      setDetalles("");
      setImagen(producto.imagen || "");
      setBrand(producto.brand || "");
    } else {
      setPvp("");
      setIvaPorcentaje(15);
      setIvaValor("0.00");
      setDescuentoPct("0");
      setStock(0);
      setDetalles("");
      setImagen("");
      setBrand("");
    }
  }, [producto]);

  useEffect(() => {
    const precio = Number(pvp) || 0;
    const porc = Number(ivaPorcentaje) || 0;
    setIvaValor(((precio * porc) / 100).toFixed(2));
  }, [pvp, ivaPorcentaje]);

  const handleAdd = () => {
    if (!producto) return;
    const precio = Number(pvp);
    if (Number.isNaN(precio)) return;

    onAdd({
      pvp: precio.toFixed(2),
      iva_porcentaje: Number(ivaPorcentaje),
      iva_valor: Number(ivaValor).toFixed(2),
      descuentoPct: String(Number(descuentoPct || 0)),
      stock: stock,
      detalles: detalles.trim(),
      is_service: producto.code?.startsWith("S"),
      brand: brand,
      imagen: imagen
    });

    setPvp("");
    setIvaPorcentaje(15);
    setIvaValor("0.00");
    setDescuentoPct("0");
    setStock(0);
    setDetalles("");
    setImagen("");
    setBrand("");
  };

  return (
    <>
      <Grid item xs={12} md={3}>
        <TextField
          label="Marca"
          value={brand}
          disabled
          fullWidth
          sx={{
            "& .Mui-disabled": {
              backgroundColor: "#f0f0f0 !important",
              color: "#333 !important",
              WebkitTextFillColor: "#333 !important"
            }
          }}
        />
      </Grid>

      <Grid item xs={12} md={3}>
        <TextField
          label="Precio Unitario"
          type="number"
          inputProps={{ step: "0.01", min: "0" }}
          value={pvp}
          onChange={(e) => setPvp(e.target.value)}
          fullWidth
        />
      </Grid>

      <Grid item xs={12} md={3}>
        <FormControl fullWidth>
          <InputLabel>IVA (%)</InputLabel>
          <Select value={ivaPorcentaje} label="IVA (%)" onChange={(e) => setIvaPorcentaje(e.target.value)}>
            <MenuItem value={0}>0%</MenuItem>
            <MenuItem value={5}>5%</MenuItem>
            <MenuItem value={15}>15%</MenuItem>
            <MenuItem value={999}>No objeto</MenuItem>
          </Select>
        </FormControl>
      </Grid>

      <Grid item xs={12} md={3}>
        <TextField
          label="IVA ($)"
          value={`$${ivaValor}`}
          disabled
          fullWidth
          sx={{
            "& .Mui-disabled": {
              backgroundColor: "#f0f0f0 !important",
              color: "#333 !important",
              WebkitTextFillColor: "#333 !important"
            }
          }}
        />
      </Grid>

      <Grid item xs={12} md={3}>
        <TextField
          label="Descuento (%)"
          type="number"
          inputProps={{ step: "0.01", min: "0", max: "100" }}
          value={descuentoPct}
          onChange={(e) => setDescuentoPct(e.target.value)}
          fullWidth
        />
      </Grid>

      <Grid item xs={12} md={3}>
        <TextField
          label="Stock"
          value={stock}
          disabled
          fullWidth
          sx={{
            "& .Mui-disabled": {
              backgroundColor: "#f0f0f0 !important",
              color: "#333 !important",
              WebkitTextFillColor: "#333 !important"
            }
          }}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <TextField
          label="Detalles adicionales"
          value={detalles}
          onChange={(e) => setDetalles(e.target.value)}
          fullWidth
        />
      </Grid>

      <Grid item xs={12} md={3}>
        <Button variant="contained" sx={{ backgroundColor: "#1565C0" }} onClick={handleAdd} fullWidth>
          AÑADIR ITEM
        </Button>
      </Grid>

      {imagen ? (
        <Grid item xs={12}>
          <Box
            sx={{
              width: 220,
              height: 220,
              border: "1px solid #ccc",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              overflow: "hidden",
              borderRadius: 2,
              mx: "auto"
            }}
          >
            <img
              src={imagen}
              alt={producto?.name || "Item"}
              style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }}
            />
          </Box>
        </Grid>
      ) : null}
    </>
  );
}
